<template>
  <ResetPasswordRequest />
</template>

<script>
import ResetPasswordRequest from "@/components/Auth/ResetPasswordRequest/Request.vue";

export default {
  name: "PasswordRequestView",
  components: {
    ResetPasswordRequest,
  },
};
</script>
